import React from "react";
var __jsx = React.createElement;
import { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useLastModifiedDuration } from 'libs/content/hooks';
import { CTAButton, CTAContainer, CTAText, CTATextInfo } from '../common/style';
import { LastSaveSince, SaveIcon } from './SaveButton.style';

var SaveButton = function SaveButton(_ref) {
  var onClick = _ref.onClick,
      lastModified = _ref.lastModified;
  var intl = useIntl();
  var isLasModifiedDefined = undefined !== lastModified && '' !== lastModified;
  var lastModifiedDate = useMemo(function () {
    return isLasModifiedDefined ? new Date(lastModified) : new Date();
  }, [isLasModifiedDefined, lastModified]);

  var _useLastModifiedDurat = useLastModifiedDuration(lastModifiedDate),
      days = _useLastModifiedDurat.days,
      durationText = _useLastModifiedDurat.durationText,
      hours = _useLastModifiedDurat.hours,
      minutes = _useLastModifiedDurat.minutes;

  var colorType = useMemo(function () {
    if (days || hours) {
      return 'error';
    }

    switch (true) {
      case minutes < 5:
        return 'success';

      case minutes < 20:
        return 'warning';

      default:
        return 'error';
    }
  }, [days, hours, minutes]);
  return __jsx(CTAContainer, {
    onClick: onClick
  }, __jsx(CTAButton, {
    "aria-label": intl.formatMessage({
      id: 'content.edit.call-to-actions.save'
    })
  }, __jsx(SaveIcon, null)), __jsx(FormattedMessage, {
    tagName: CTAText,
    id: 'content.edit.call-to-actions.save'
  }), isLasModifiedDefined && __jsx(CTATextInfo, null, __jsx(FormattedMessage, {
    tagName: "span",
    id: 'date.last-save'
  }), __jsx(LastSaveSince, {
    variant: colorType
  }, __jsx(FormattedMessage, {
    id: 'date.last-save-since',
    values: {
      duration: durationText
    }
  }))));
};

export default SaveButton;